import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import { Container, Row, Col, Card, CardHeader, Button, Input } from "@/Components/ui";
;
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useAuthContext } from "../../Components/AuthContext";
import { SUBDOMAIN } from "../../assets/meta/meta";
import { membershipService } from "../../api/services/membership.service";
import { dialogService } from "@/utils/dialogService";
import { getPermissionOptions } from "./memberPermissions";

const MemberInvitePage = () => {
    const navigate = useNavigate();
    const { userInfo } = useAuthContext();
    const sitePermission = userInfo?.site_permission;
    const actorPermission = Number(sitePermission?.permission || 0);
    const canInvite = !!(sitePermission &&
        actorPermission >= 1 &&
        (actorPermission === 2 || sitePermission.subdomain === SUBDOMAIN));
    const permissionOptions = getPermissionOptions(actorPermission);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: "",
            permission: permissionOptions[0]?.value || 0,
        },
        validationSchema: Yup.object({
            email: Yup.string().email("유효한 이메일을 입력해주세요.").required("이메일이 필요합니다."),
            permission: Yup.number().min(0, "권한을 선택해주세요."),
        }),
        onSubmit: async (values) => {
            if (!sitePermission?.site) {
                await dialogService.handleAlert("사이트 정보를 찾을 수 없습니다.");
                return;
            }
            if (!canInvite) {
                await dialogService.handleAlert("현재 지점에 대한 멤버 초대 권한이 없습니다.");
                return;
            }
            try {
                await membershipService.createMemberInvitation(sitePermission.site, {
                    email: values.email.trim().toLowerCase(),
                    permission: values.permission,
                });
                toast.success("초대가 발송되었습니다.");
                navigate("/member-list");
            }
            catch (error) {
                console.log("createMemberInvitation error", error);
                toast.error("초대 발송에 실패했습니다.");
            }
        },
    });
    if (!canInvite) {
        return (<div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="border-0">
                  <h5 className="card-title mb-0">권한이 없습니다.</h5>
                </CardHeader>
                <div className="card-body">
                  <p className="text-danger mb-0">
                    멤버 초대 기능을 사용할 권한이 없습니다.
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>);
    }
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="멤버 초대" pageTitle="멤버 관리"/>
          <Row className="justify-content-center">
            <Col lg={6}>
              <Card id="memberInviteCard">
                <CardHeader className="border-0">
                  <h5 className="card-title mb-0">멤버 초대</h5>
                </CardHeader>
                <div className="card-body">
                  <form onSubmit={(event) => {
            event.preventDefault();
            formik.handleSubmit();
            return false;
        }}>
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">
                        이메일
                      </label>
                      <Input type="email" id="email" name="email" className="form-control" placeholder="invitation@example.com" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email}/>
                      {(formik.touched.email && formik.errors.email) ? (<div className="invalid-feedback d-block">{formik.errors.email}</div>) : null}
                    </div>

                    <div className="mb-4">
                      <label htmlFor="permission" className="form-label">
                        권한
                      </label>
                      <select id="permission" name="permission" className="form-select" onChange={formik.handleChange} value={formik.values.permission}>
                        {permissionOptions.map((option) => (<option key={option.value} value={option.value}>
                            {option.label} ({option.value})
                          </option>))}
                      </select>
                      {(formik.touched.permission && formik.errors.permission) ? (<div className="invalid-feedback d-block">{formik.errors.permission}</div>) : null}
                    </div>

                    <div className="text-end">
                      <Button type="submit" color="success">
                        초대하기
                      </Button>
                    </div>
                  </form>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Toaster position="top-center"/>
    </React.Fragment>);
};
export default MemberInvitePage;
